import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';

export const userListColumns = [
  'user.id',
  'user.email',
  'user.providerId',
  'user.providerRgs.rgsId',
  'user.roleIds',
  'user.isProviderUsersAdmin',
] as const;

export type UserListColumns = (typeof userListColumns)[number];

export type UserListFilter = {
  'user.id': string | undefined;
  'user.email': string | undefined;
  'user.providerId': string | undefined;
  'user.providerRgs.rgsId': string | undefined;
  'user.roleIds': string[] | undefined;
  'user.isProviderUsersAdmin': boolean | undefined;
};

export const defaultUserListFilter: UserListFilter = {
  'user.id': undefined,
  'user.email': undefined,
  'user.providerId': undefined,
  'user.providerRgs.rgsId': undefined,
  'user.roleIds': undefined,
  'user.isProviderUsersAdmin': undefined,
};

export const userListColumnVisibilitySettings = {
  'user.id': ColumnVisibilityType.Visible,
  'user.email': ColumnVisibilityType.CanBeHidden,
  'user.providerId': ColumnVisibilityType.CanBeHidden,
  'user.providerRgs.rgsId': ColumnVisibilityType.CanBeHidden,
  'user.roleIds': ColumnVisibilityType.CanBeHidden,
  'user.isProviderUsersAdmin': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<UserListColumns>;

export const defaultUserListColumnVisibility = defaultColumnVisibilityParams(
  userListColumnVisibilitySettings
);

export const userListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  userListColumns,
  userListColumnVisibilitySettings
);
